import { Faro } from "@grafana/faro-web-sdk";

const perfInit = (faroInstance: Faro, ignoreEvents: string[]): void => {
  const perfObserver = (list: PerformanceObserverEntryList): void => {
    list.getEntries().forEach((entry: PerformanceEntry) => {
      const { name, duration, entryType, startTime } = entry;
      let ignoreEntry = false;
      ignoreEvents.forEach((elem) => {
        const reg = new RegExp(elem);
        if (reg.test(name)) {
          ignoreEntry = true;
        }
      });
      if (!ignoreEntry) {
        const entryjson = {
          name: name,
          duration: duration,
          entryType: entryType,
          startTime: performance.timeOrigin + startTime,
          endTime: performance.timeOrigin + startTime + duration
        };
        faroInstance.api.pushLog([JSON.stringify(entryjson)]);

        if (entryType === "measure") {
          faroInstance.api.pushMeasurement({
            type: "performance-measure",
            values: {
              [name]: duration
            }
          });
        }
      }
    });
  };
  const observer = new PerformanceObserver(perfObserver);
  observer.observe({ entryTypes: ["mark", "measure"] });
};

export default perfInit;
